import { defineComponent as _defineComponent } from 'vue'
import { ModalWrapper } from '@/shared/ui/modals'
import { mediaApi, MediaDB } from '@/enitites/media'
import { ref, watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'BKMediaEditor',
  props: {
    isShowEditor: { type: Boolean },
    orgId: null,
    eventId: null
  },
  emits: ["update:isShowEditor", "save"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:isShowEditor', value: boolean): void
  (e: 'save', value: MediaDB[]): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  isShowEditor: boolean
  orgId: number
  eventId: number
};





const newMedia = ref<MediaDB>({
  link: '',
  name: '',
  id: 0,
  userId: 0,
})

const videoUrl = ref('')
const videoEmbedUrl = ref('')

function resetMediaEditor() {
  videoUrl.value = ''
  videoEmbedUrl.value = ''
  newMedia.value = {
    link: '',
    name: '',
    id: 0,
    userId: 0,
  }
}

function getYouTubeMediaId(url: string) {
  const match = url.match(/(?:[?&]v=|\/embed\/|\/1\/|\/v\/|https:\/\/(?:www\.)?youtu\.be\/)([^&\n?#]+)/)
  if (match) {
    const [, id] = match
    return id
  }
  return null
}

function addMedia() {
  const mediaId = getYouTubeMediaId(videoUrl.value)

  if (!mediaId) return

  videoEmbedUrl.value = `https://www.youtube.com/embed/${mediaId}`
  newMedia.value.link = mediaId
}

async function saveMedia() {
  const mediaPayload = { ...newMedia.value, orgId: props.orgId, eventId: props.eventId }
  const updatedMedia = await mediaApi.addMedia(mediaPayload)
  if (updatedMedia) emit('save', updatedMedia)
}

watch(
  () => props.isShowEditor,
  (val) => {
    if (!val) {
      resetMediaEditor()
    }
  }
)

return { __sfc: true,props, emit, newMedia, videoUrl, videoEmbedUrl, resetMediaEditor, getYouTubeMediaId, addMedia, saveMedia, ModalWrapper }
}

})